import CounsellorCard from '../components/CounsellorCard';
import Meta from '../components/Meta';

const counsellors = [
  {
    name: "Kristina Sohal",
    title: "RCC, Registered Clinical Counsellor",
    image: "/images/Kristina_Sohal-optimized.webp",
    languages: ["English", "Punjabi"],
    description: `I'm Kristina, a registered counsellor in Vancouver who helps transform lives through compassionate and non-judgmental therapy.

**My Journey**
My path to counselling began in the finance industry, where I worked for several years. While helping clients with financial stress, I discovered my true passion for supporting people through their challenges. This led me to pursue a career in therapy, earning my Masters of Counselling Psychology from Yorkville University.

**My Approach**
As a member of the British Columbia Association of Counsellors, I take pride in:
• Providing a safe, non-judgmental space for healing
• Taking time to truly listen and understand each client's unique journey
• Offering personalized tools for positive life changes

**Therapeutic Methods**
I employ various evidence-based approaches including:
• Cognitive Behavioural Therapy (CBT)
• Mindful Exercises
• Solution-Focused Therapy
• Person Centered Therapy
• Exposure Therapy
• Empty Chair Techniques`,
  },
  {
    name: "Karin Gorseth",
    title: "MSW-RSW, Registered Social Worker",
    image: "/images/karen_gorseth.webp",
    languages: ["English"],
    description: `Karin Gorseth works with individuals and families in therapy to bring deeper meaning and clarity to their lives. She believes in honoring the experiences of others as a vehicle for self-exploration and deepened understanding of oneself.

**Professional Background** Certified in psychoanalytic psychotherapy from the Contemporary Freudian Society (New York City). Master of Social Work from Hunter College Silberman School of Social Work. Bachelor's degree in Social Work from Seattle University

**Areas of Expertise** Individual and family therapy,  Trauma-focused treatment modalities, Psychoanalytic psychotherapy. Life transitions and personal growth. Specialized training in trauma-focused treatment approaches.

**Approach to Therapy** Karin's therapeutic approach is rooted in creating a safe, non-judgmental space where clients can explore their thoughts and feelings. She works collaboratively with clients to develop personalized strategies that align with their goals and values.    
`,
  },
  {
    name: "Sarvenaz Amiri",
    title: "RCC, Registered Clinical Counsellor",
    image: "/images/sarvenaz-amiri-optimized.webp",
    languages: ["English", "Farsi"],
    description: `**Professional Background**
As a Registered Clinical Counsellor (RCC), I am dedicated to supporting individuals through life's challenges with compassion, understanding, and evidence-based care. My clinical experience includes working with clients experiencing:
• Anxiety and depression
• Trauma and PTSD
• ADHD and emotional regulation difficulties
• Relationship and family concerns
• Parenting challenges
• Life transitions and adjustment issues
• Self-esteem and identity development

**Therapeutic Approaches**
My work is grounded in a client-centered, trauma-informed, and culturally responsive framework. I integrate evidence-based approaches including:
• Cognitive Behavioral Therapy (CBT)
• Solution-Focused Therapy
• Strengths-Based Therapy
• Mindfulness-Based Interventions
• Attachment-Informed Approaches
• Trauma-Informed Care

**Areas of Focus**
I support clients in:
• Healing from difficult life experiences and trauma
• Managing anxiety, depression, and stress
• Building emotional resilience and self-awareness
• Improving relationships and communication skills
• Navigating family and parenting challenges
• Strengthening self-confidence and personal growth
• Creating meaningful and lasting life changes

My passion is helping individuals better understand themselves, overcome barriers to growth, and build healthier relationships with themselves and others. Together, we work toward greater balance, resilience, and a life that feels authentic and fulfilling.`,
  },
  {
    name: "Cynthia Csepregi",
    title: "RCC, BA in Social Work",
    image: "/images/Cynthia-Csepregi-min-optimized.webp",
    languages: ["English"],
    description: `**Welcome**
I'm Cynthia, and I'm excited to be part of the Metro Counselling team. As a registered Social Worker and Counsellor, I believe strongly in people's capacity for positive change.

**Professional Journey**
My career path includes:
• 14 years in complex mental health settings
• Extensive work in non-profit organizations
• Experience with developmental disabilities programs
• Masters in Counselling from City University of Seattle
• Specialized research in the impact of suicide on families

**Counselling Philosophy**
I bring to my practice:
• A strengths-based approach
• Extensive mental health experience
• Deep empathy and understanding
• Commitment to supporting positive change
• Specialized crisis intervention training

My greatest satisfaction comes from helping clients become architects of change in their own lives. I look forward to being part of your journey toward positive transformation.`,
  },
  {
    name: "Fatemeh Poorrezvan",
    title: "RCC, Registered Clinical Counsellor",
    image: "/images/venus1-optimized.webp",
    languages: ["English", "Farsi", "Turkish"],
    description: `**Professional Credentials**
• BCACC Registered Clinical Counselor
• Member of the American Psychological Association (APA)
• Master's degree in Clinical Psychology
• Specialized training in Autism and Neurodiversity
• Expertise in Addiction Management

**Research & Experience**
My research has focused on:
• Hope and expectation in medical settings
• Behavioral discipline and self-efficacy
• Anxiety management in surgical patients
• 13+ years of clinical consultation experience
• Extensive work with diverse patient populations

**Clinical Approach**
I am inspired by:
• Human resilience and healing potential
• Client-centered therapy
• Evidence-based practices
• Collaborative treatment planning
• Multicultural counselling perspectives

Through my hospital experience and work with thousands of patients, I've developed a deep appreciation for the human capacity for growth and healing.`,
  },
  {
    name: "Rafael Tejada",
    title: "RCC, Registered Clinical Counsellor",
    image: "/images/rafeal-optimized.webp",
    languages: ["English", "Spanish"],
    description: `**Areas of Expertise**
I specialize in helping clients navigate:
• Trauma and recovery
• Anxiety and depression
• Personality disorders
• Addiction challenges
• Relationship dynamics
• Family communication

**Therapeutic Focus**
My work centers on:
• Examining attachment difficulties
• Healing relationship injuries
• Building self-understanding
• Developing healthy connections
• Restoring self-esteem and hope

**Counselling Philosophy**
I believe in:
• Facing challenges with kindness
• Building compassionate perspectives
• Embracing our whole selves
• Working collaboratively toward goals
• Creating lasting positive change

Together, we'll work to understand your experiences and build a path toward inner peace and stronger relationships.`,
  },
  {
    name: "Beth Mares",
    title: "Self-Care Coach & Therapeutic Touch Practitioner",
    image: "/images/beth_hq-optimized.webp",
    languages: ["English"],
    description: `Beth is a seasoned Self-Care Coach and Therapeutic Touch Practitioner with extensive experience in Quantum and Ancient Healing Modalities. Specializing in Holistic Bodywork, Massage, and Therapeutic Touch Techniques, Beth's practice blends scientific rigor with spiritual wisdom.

With her compassionate touch, Beth harmonizes individuals' energy fields, aiming to balance and clear their bio-energetic systems. She has spent years working in medical settings, helping diverse clients heal from chronic health conditions. Beth is convinced that energy work and self-care are pivotal for the future of medicine.`,
  },
  {
    name: "Albin Issac",
    title: "RCC, Registered Clinical Counsellor",
    image: "/images/albin-optimized.webp",
    languages: ["English", "Malayalam", "Tamil"],
    description: `I'm Albin, a Registered Clinical Counsellor in British Columbia dedicated to helping individuals, couples, and families build resilience, strengthen relationships, and find hope through life's challenges.

**My Journey**
My path to counselling began with a strong interest in supporting people through emotional and relational struggles. I earned my Master of Science in Counselling and Family Therapy and am completing my Master of Arts in Leadership (Healthcare) at Trinity Western University. This academic foundation, combined with practical clinical experience, allows me to provide holistic and client-centered care.

**My Approach**
As a member of the British Columbia Association of Clinical Counsellors, I take pride in:
• Creating a safe, supportive, and culturally sensitive space
• Listening deeply to understand each client's unique journey
• Offering strategies that promote emotional well-being, healing, and growth

**Therapeutic Methods**
I use a range of evidence-based approaches tailored to client needs, including:
• Cognitive Behavioral Therapy (CBT)
• Solution-Focused Brief Therapy (SFBT)
• Trauma-Focused CBT (TF-CBT)
• Emotionally Focused Therapy (EFT) for couples and families
• Mindfulness-Based Cognitive Therapy (MBCT)
• Person-Centered Therapy
• Christian Counselling Approaches
• Trauma-Informed Practice

**BCACC Membership ID: 24646**`,
  },
];

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Meta 
        title="About Metro Counselling | Professional Therapists in Surrey, BC"
        description="Meet our experienced team of registered clinical counsellors in Surrey, BC. Providing compassionate mental health care in English and Punjabi. Learn about our approach to therapy."
      />
      
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Surrey Registered Counsellors | Over 10 Years of Care
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Accredited, trauma-informed therapy for individuals, couples, and families. In person and online.
          </p>
        </div>
      </div>

      {/* Team Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3">
          {counsellors.map((counsellor, index) => (
            <article key={index} className="prose prose-lg max-w-none">
              <CounsellorCard {...counsellor} />
            </article>
          ))}
        </div>
      </div>

      {/* Mission Section */}
      <section className="bg-gray-50 py-16 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
              Our Commitment to Mental Health Care
            </h2>
            <p className="text-gray-600 mb-6">
              At Metro Counselling, we believe in providing accessible, compassionate, and effective mental health care 
              to our community in Surrey and the surrounding areas. Our team of registered clinical counsellors brings 
              diverse expertise and cultural understanding to support your journey towards wellness.
            </p>
            <p className="text-gray-600">
              Whether you're seeking individual counselling, couples therapy, or specialized mental health support, 
              our experienced team is here to help. We offer services in multiple languages and use evidence-based 
              therapeutic approaches tailored to your unique needs.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-gradient-to-r from-brand-teal to-brand-teal-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Start Your Journey?</h2>
          <p className="text-xl mb-8">
            Take the first step towards positive change with our experienced counselling team.
          </p>
          <a
            href="tel:604-619-9992"
            className="inline-flex items-center bg-white text-brand-teal px-8 py-4 rounded-lg text-lg font-medium hover:bg-gray-50 transition-colors"
          >
            Call Us: 604-619-9992
          </a>
        </div>
      </section>
    </div>
  );
}
